// src/components/PasswordGenerator.tsx
import React, { useState } from 'react';
import '../styles/PasswordGenerator.css';

const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const lowerCase = upperCase.toLowerCase();
const numbers = "0123456789";
const specialChars = "!@#$%^&*()";

const getRandomChar = (chars: string) => chars[Math.floor(Math.random() * chars.length)];

const generatePassword = (useUpper: boolean, useLower: boolean, useNumbers: boolean, useSpecial: boolean): string => {
  let charset = '';
  if (useUpper) charset += upperCase;
  if (useLower) charset += lowerCase;
  if (useNumbers) charset += numbers;
  if (useSpecial) charset += specialChars;

  if (!charset) return '';

  let password = '';
  while (password.length < 9) {
    password += getRandomChar(charset);
  }

  return password;
};

const PasswordGenerator: React.FC = () => {
  const [password, setPassword] = useState('');
  const [useUpper, setUseUpper] = useState(true);
  const [useLower, setUseLower] = useState(true);
  const [useNumbers, setUseNumbers] = useState(true);
  const [useSpecial, setUseSpecial] = useState(true);

  const handleGenerate = () => {
    const pwd = generatePassword(useUpper, useLower, useNumbers, useSpecial);
    setPassword(pwd);
  };

  const handleCopy = () => {
    if (password) {
      navigator.clipboard.writeText(password)
        .then(() => setPassword('Copied!'))
        .then(() => setTimeout(() => setPassword(generatePassword(useUpper, useLower, useNumbers, useSpecial)), 2000))
        .catch(console.error);
    }
  };

  return (
    <div className="panelY-2 blue">
        <div className="bg-password">
            <div className="password-title">
                <h2>Password Generator</h2>
            </div>
            <div className="password-content">
                <div className="pwd-img"></div>
                
                <p>Generate a strong password by selecting all the check boxes</p>
                <div className="pwOptions">
                  <label><input type="checkbox" checked={useUpper} onChange={() => setUseUpper(!useUpper)} /> Uppercase</label>
                </div>
                
                <div className="pwOptions">
                  <label><input type="checkbox" checked={useLower} onChange={() => setUseLower(!useLower)} /> Lowercase</label>
                </div>
                
                <div className="pwOptions">
                  <label><input type="checkbox" checked={useNumbers} onChange={() => setUseNumbers(!useNumbers)} /> Numbers</label>
                </div>

                <div className="pwOptions">
                  <label><input type="checkbox" checked={useSpecial} onChange={() => setUseSpecial(!useSpecial)} /> Special Characters</label>
                </div>

                <div>
                    <div className="generatePasswordBtn" id="generatePasswordBtn" title="Click to generate password" onClick={handleGenerate} >
                      <button className="btn-no-border" onClick={handleGenerate}>Generate Password</button>
                    </div>
        
                    <div className="passwordBtn ">
                        <span id="pwdContent">{password}</span>
                        <div className="copyPassword" id="copyPassword" onClick={handleCopy} title="Copy">
                          <button className="btn-no-border" onClick={handleCopy}>
                              <i className="fas fa-copy"></i>
                          </button>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

  );
};

export default PasswordGenerator;
